// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ArrowRightSvg from '@rsuite/icon-font/lib/direction/ArrowRight';
var ArrowRight = createSvgIcon({
    as: ArrowRightSvg,
    ariaLabel: 'arrow right',
    category: 'direction',
    displayName: 'ArrowRight'
});
export default ArrowRight;
